import { useFormik } from 'formik';

interface FormFieldProps {
  label: string;
  name: string;
  type?: 'text' | 'number' | 'textarea';
  placeholder?: string;
  disabled?: boolean;
  formik: ReturnType<typeof useFormik<any>>;
  className?: string;
}

export const FormField = ({ 
  label, 
  name, 
  type = 'text', 
  placeholder, 
  disabled,
  formik,
  className = ''
}: FormFieldProps) => {
  const isTextarea = type === 'textarea';
  const Component = isTextarea ? 'textarea' : 'input';
  const hasError = formik.touched[name] && formik.errors[name];

  return (
    <div>
      <label className="block text-sm font-medium mb-2">
        {label}
      </label>
      <Component
        type={type}
        {...formik.getFieldProps(name)}
        className={`${
          isTextarea ? 'textarea' : 'input'
        } input-bordered w-full ${
          hasError ? 'input-error' : ''
        } ${isTextarea ? 'h-24' : ''} ${className}`}
        placeholder={placeholder}
        disabled={disabled}
      />
      {hasError && (
        <div className="text-error text-sm mt-1">{formik.errors[name] as string}</div>
      )}
    </div>
  );
}; 